function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React, { useEffect, useRef } from 'react';
import { StyledDropdownOverlay, StyledDropdownMenu } from './DropdownMenu.styles'; // 스타일 컴포넌트 임포트
import Portal from '../../../common/Portal';
/**
 * DropdownMenu - 드롭다운 메뉴 컨테이너 컴포넌트
 * 
 * 어떤 컴포넌트에서든 재사용 가능한 드롭다운 메뉴를 제공합니다.
 * 위치와 정렬 방식을 조절할 수 있습니다.
 */ var DropdownMenu = function(param) {
    var isOpen = param.isOpen, children = param.children, _param_position = param.position, position = _param_position === void 0 ? 'bottom' : _param_position, _param_align = param.align, align = _param_align === void 0 ? 'end' : _param_align, _param_width = param.width, width = _param_width === void 0 ? '12rem' : _param_width, _param_className = param.className, className = _param_className === void 0 ? '' : _param_className, onClose = param.onClose, triggerRef // 추가
     = param.triggerRef;
    var menuRef = useRef(null);
    var _React_useState = _sliced_to_array(React.useState({
        top: 0,
        left: 0,
        visibility: 'hidden'
    }), 2), menuPosition = _React_useState[0], setMenuPosition = _React_useState[1];
    // 외부 클릭 및 Escape 키 처리
    useEffect(function() {
        if (!isOpen || !onClose) return;
        var handleInteractionOutside = function(event) {
            if (event.type === 'keydown') {
                if (event.key === 'Escape') {
                    onClose();
                }
                return;
            }
            // Check if the click is outside the menu element
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                onClose();
            }
        };
        document.addEventListener('mousedown', handleInteractionOutside);
        document.addEventListener('touchstart', handleInteractionOutside);
        document.addEventListener('keydown', handleInteractionOutside);
        return function() {
            document.removeEventListener('mousedown', handleInteractionOutside);
            document.removeEventListener('touchstart', handleInteractionOutside);
            document.removeEventListener('keydown', handleInteractionOutside);
        };
    }, [
        isOpen,
        onClose
    ]);
    // 트리거 ref로 위치 계산
    useEffect(function() {
        if (isOpen && (triggerRef === null || triggerRef === void 0 ? void 0 : triggerRef.current) && menuRef.current) {
            var _window_visualViewport, _window_visualViewport1;
            var triggerRect = triggerRef.current.getBoundingClientRect();
            var menu = menuRef.current;
            // 일단 숨긴 상태로 렌더링해서 실제 크기 측정
            menu.style.visibility = 'hidden';
            menu.style.display = 'block';
            var menuRect = menu.getBoundingClientRect();
            // 모바일 안전 영역 고려
            var safeAreaTop = 8;
            var safeAreaBottom = 8;
            var safeAreaSides = 8;
            // 뷰포트 크기 (모바일 브라우저 UI 고려)
            var viewportHeight = ((_window_visualViewport = window.visualViewport) === null || _window_visualViewport === void 0 ? void 0 : _window_visualViewport.height) || window.innerHeight;
            var viewportWidth = ((_window_visualViewport1 = window.visualViewport) === null || _window_visualViewport1 === void 0 ? void 0 : _window_visualViewport1.width) || window.innerWidth;
            var top = triggerRect.bottom;
            var left = triggerRect.left;
            // 아래로 띄웠을 때 화면을 벗어나면 위로
            if (top + menuRect.height + safeAreaBottom > viewportHeight) {
                top = triggerRect.top - menuRect.height;
                // 위로도 벗어나면 최대한 화면에 맞추기
                if (top < safeAreaTop) {
                    top = safeAreaTop;
                }
            }
            // 오른쪽을 벗어나면 왼쪽으로
            if (left + menuRect.width + safeAreaSides > viewportWidth) {
                left = viewportWidth - menuRect.width - safeAreaSides;
            }
            // 왼쪽도 벗어나면 안전 영역으로
            if (left < safeAreaSides) {
                left = safeAreaSides;
            }
            setMenuPosition({
                top: top,
                left: left,
                visibility: 'visible'
            });
        }
    }, [
        isOpen,
        triggerRef
    ]);
    // isOpen이 false가 될 때 위치 상태 초기화
    useEffect(function() {
        if (!isOpen) {
            setMenuPosition({
                top: 0,
                left: 0,
                visibility: 'hidden'
            });
        }
    }, [
        isOpen
    ]);
    if (!isOpen) return null;
    var handleOverlayClick = function(e) {
        e.stopPropagation();
        if (onClose) {
            onClose();
        }
    };
    return /*#__PURE__*/ React.createElement(Portal, null, /*#__PURE__*/ React.createElement(React.Fragment, null, onClose && /*#__PURE__*/ React.createElement(StyledDropdownOverlay, {
        onClick: handleOverlayClick
    }), /*#__PURE__*/ React.createElement(StyledDropdownMenu, {
        ref: menuRef,
        style: {
            position: 'fixed',
            top: menuPosition.top,
            left: menuPosition.left,
            visibility: menuPosition.visibility,
            zIndex: 9999,
            width: width,
            maxWidth: '90vw',
            height: 'fit-content',
            maxHeight: '50vh',
            overflowY: 'auto',
            boxSizing: 'border-box',
            // @ts-ignore - WebkitOverflowScrolling is a vendor-specific property
            WebkitOverflowScrolling: 'touch'
        },
        className: className,
        onClick: function(e) {
            return e.stopPropagation();
        }
    }, children)));
};
export default DropdownMenu;
